"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MinimalLoader_1 = require("../../../common/components/presentation/MinimalLoader/MinimalLoader");
var useWidgetContext_1 = require("../../../common/react/useWidgetContext");
var assetManager_1 = require("../../../../../common/service/assetManager");
var constants_1 = require("../../../common/constants/constants");
var fcConfig_1 = require("../../../common/constants/fcConfig");
var ViewModeType_1 = require("../../../gql/checkout4/enum/ViewModeType");
var errorHandler_1 = require("../../../common/service/errorHandler");
var FinanceCalculatorWidget = function (_a) {
    var carConfiguration = _a.carConfiguration, postcode = _a.postcode;
    var widgetId = react_1.useMemo(function () { return 'dxp-finance-calculator-container' + Math.floor(Math.random() * 100); }, []);
    var widgetInstance = react_1.useRef(null);
    var fcLibrary = react_1.useRef(null);
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var _b = react_1.useState(false), isLoading = _b[0], setLoadingStatus = _b[1];
    var ensureLibraryLoaded = function () {
        var widgetUrl = fcConfig_1.default.dxpWidgetUrl;
        if (assetManager_1.assetManager.isScriptLoaded(widgetUrl)) {
            if (!fcLibrary.current && window.DXPFinanceCalculator) {
                fcLibrary.current = window.DXPFinanceCalculator;
            }
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(function () {
            // keep in mind there's a slight difference between the react versions of dxp and auto-widgets
            if (!assetManager_1.assetManager.isScriptLoaded(constants_1.default.REACT_DEPENDENCIES.react18)) {
                return assetManager_1.assetManager
                    .loadScript(constants_1.default.REACT_DEPENDENCIES.react18)
                    .then(function () { return assetManager_1.assetManager.loadScript(constants_1.default.REACT_DEPENDENCIES.reactDom18); });
            }
        })
            .then(function () { return assetManager_1.assetManager.loadScript(widgetUrl, 'module'); })
            .then(function () {
            fcLibrary.current = window.DXPFinanceCalculator;
        });
    };
    var getLibrary = react_1.useCallback(function () {
        if (!fcLibrary.current) {
            throw new Error("Attempted to use DXP Finance Calculator library without loading it first");
        }
        return fcLibrary.current;
    }, [fcLibrary.current]);
    var initializeWidget = function () {
        if (widgetInstance.current) {
            widgetInstance.current.destroy();
        }
        setLoadingStatus(true);
        var widgetConfig = {
            containerId: widgetId,
            viewMode: ViewModeType_1.ViewType.FULL,
            car: {
                code: carConfiguration,
                featureCodes: {
                    values: [],
                },
            },
            postcode: postcode,
            dimensions: dimensions,
            version: 'new',
        };
        var dxpWidget = getLibrary();
        dxpWidget.createFinanceCalculatorWidget(widgetConfig);
    };
    react_1.useEffect(function () {
        if (!widgetInstance.current) {
            ensureLibraryLoaded()
                .then(function () { return initializeWidget(); })
                .catch(errorHandler_1.default.promise())
                .finally(function () { return setLoadingStatus(false); });
        }
        return function () {
            if (widgetInstance.current) {
                widgetInstance.current.destroy();
            }
        };
    }, []);
    return (<>
      {isLoading && <MinimalLoader_1.default />}
      
      <div id={widgetId} data-test="checkout:finance-calculator"/>
    </>);
};
exports.default = FinanceCalculatorWidget;
